import React from "react";

const RuContent = () => {
  return (
    <div>
      <h1>Russian Content</h1>
    </div>
  );
};

export default RuContent;
